// extracted by mini-css-extract-plugin
module.exports = {"defaults":"_8a6bcde","withBackground":"_6ba65fd"};